import {createSvgIcon} from '../create-svg-icon';

export const TurnLeftIcon = createSvgIcon(
  <path d="m6.83 11 1.59 1.59L7 14l-4-4 4-4 1.41 1.41L6.83 9H15c1.1 0 2 .9 2 2v9h-2v-9H6.83z" />
, 'TurnLeftOutlined');
